<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent2"><a id="ch00_fm05"></a><a id="page_v"></a><em>This volume is dedicated to all Americans as a memorial<br/>to our countrymen who volunteered in the armed forces<br/>of the United States during our greatest national crisis.</em> <a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?986aed4a